import * as R from 'ramda';
import { Endpoints } from '../../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading } from '../../../../core/api/module';
import { ActionType } from '../../../../core/redux/actionType';
import { updateAction } from '../module';


const KEY_ACTION = ActionType.UpdateDevPlanActionCompleteByDateRequest;
const ACTIONS    = [
  ActionType.UpdateDevPlanActionCompleteByDateRequest,
  ActionType.UpdateDevPlanActionCompleteByDateResponse,
  ActionType.UpdateDevPlanActionCompleteByDateError,
];


type Payload = undefined;
type Meta = { devItemId: number; devActionId: number; completeBy: string | Date; };


/**
 * Dispatch this action to update the date that an action should be completed by
 */
export const updateDevPlanActionCompleteByDateAction = (
  devItemId: number,
  devActionId: number,
  completeBy: string | Date,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.UpdateDevPlanActionCompleteByDate,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ devActionId, completeBy }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { devItemId, devActionId, completeBy }),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, action.meta.devActionId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, action.meta.devActionId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, action.meta.devActionId);

  return updateAction(
    action.meta.devItemId,
    action.meta.devActionId,
    R.assoc('goalDate', action.meta.completeBy),
    successState,
  );
};


export const updateDevPlanActionCompleteByDateReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
